export const mediaData = [
  // {
  // 	title: "title",
  // 	photo: rosieGif,
  // 	video: null,
  // 	instagramURL: "https://www.instagram.com/rosie_thebatdog/reel/C2DJ1sgruuH/",
  // 	description: "Rosie goes to either couch or place.",
  // },
  {
    title: "Puzzle - Level 4",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/Cw6OYgmsOpU/",
    description: "Rosie figures out a puzzle",
  },
  {
    title: "Snow day",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/C4ioXcALwdh/",
    description: "Snow day",
  },

  {
    title: "Pull Socks",
    photo: null,
    video: null,
    instagramURL: "https://www.instagram.com/reel/C4opDiLPJxq/",
    description: "Pull Socks.",
  },
  {
    title: "Trick feeder",
    video: null,
    instagramURL: "https://www.instagram.com/reel/C2DJ1sgruuH/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    description: "Trick feeder.",
  },
  {
    title: "Statue Sniffer",
    video: null,
    instagramURL: "https://www.instagram.com/reel/Cj9C9UZPToD/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    description: "Rosie cautiously sniffing a statue lamb.",
  },
  {
    title: "The Smallest Bronco",
    video: null,
    instagramURL: "https://www.instagram.com/reel/CjX_4SDrEuJ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    description: "Rosie The Bronco.",
  },
  {
    title: "Rosie meets the saxophone",
    video: null,
    instagramURL: "https://www.instagram.com/reel/Cb5fdWPJEGv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    description: "Saxophone.",
  },
];
